import { APP_ROUTES } from "../constants";
import type { ICashDepositContext } from "../interfaces/cash-deposit";

/** Context (or an equivalent funding-policy payload) has arrived. */
export function isFundingPolicyReady(
  context: ICashDepositContext | null | undefined,
): boolean {
  return context != null;
}

/** True only when Superadmin InComm policy asks the customer to choose a chain. */
export function requiresCustomerToChooseChain(
  context: ICashDepositContext | null | undefined,
): boolean {
  return context?.requireCustomerToChooseChain === true;
}

/** True only when Superadmin InComm policy refreshes the barcode after an amount mismatch. */
export function refreshesBarcodeOnAmountMismatch(
  context: ICashDepositContext | null | undefined,
): boolean {
  return context?.refreshBarcodeOnAmountMismatch === true;
}

/** After landing / how-to: picker when required, otherwise the barcode screen. */
export function cashDepositNextRoute(
  context: ICashDepositContext | null | undefined,
): string {
  return requiresCustomerToChooseChain(context)
    ? APP_ROUTES.STORES_PAGE
    : APP_ROUTES.CASH_STORES_PAGE;
}
